"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var localized_strings_1 = require("localized-strings");
exports.areaUnits = new localized_strings_1.default({
    en: {
        Acre: {
            AbbreviatedDisplay: 'ac.',
            FullDisplay: 'acres'
        },
        Are: {
            AbbreviatedDisplay: 'are',
            FullDisplay: 'ares'
        },
        Hectare: {
            AbbreviatedDisplay: 'ha',
            FullDisplay: 'hectares'
        },
        SquareFoot: {
            AbbreviatedDisplay: 'ft²',
            FullDisplay: 'square feet'
        },
        SquareMeter: {
            AbbreviatedDisplay: 'm²',
            FullDisplay: 'square meters'
        },
        SquareMile: {
            AbbreviatedDisplay: 'mi²',
            FullDisplay: 'square miles'
        }
    },
    es: {
        Acre: {
            AbbreviatedDisplay: 'ac.',
            FullDisplay: 'acres'
        },
        Are: {
            AbbreviatedDisplay: 'are',
            FullDisplay: 'ares'
        },
        Hectare: {
            AbbreviatedDisplay: 'ha',
            FullDisplay: 'hectareas'
        },
        SquareMeter: {
            AbbreviatedDisplay: 'm²',
            FullDisplay: 'metros cuadrados'
        },
        SquareMile: {
            AbbreviatedDisplay: 'mi²',
            FullDisplay: 'millas cuadradas'
        }
    }
}, {
    logsEnabled: false
});
